/* eslint-disable no-template-curly-in-string */

import useInitialEmailStateSendOrderRequest from '@frontend/applications/ProductFulfillmentApp/CreatorProductSelection/utils/initialEmailStateSendOrderRequest';
import { TProject } from '../../types';

export const useDefaultProductEmailTemplate = (program?: TProject) => {
  const programTitle = program?.title || 'Program';

  const [
    subject,
    {
      blocks,
      entityMap,
    },
  ] = useInitialEmailStateSendOrderRequest(program?.title, program?.id);

  return {
    title: `Product Email Template for ${programTitle}`,
    subject,
    text: JSON.stringify({
      blocks,
      entityMap,
    }),
  };
};
